import { addColumnHeader } from "../helpers";
import { getMaxColumnLenght } from "../utils";

export const insertUserDefinedDataInSheet = (
  outputSheet,
  outputColumns,
  rule,
) => {
  addColumnHeader(outputSheet, outputColumns, rule.outColChr);

  let { length } = getMaxColumnLenght(outputSheet);
  for (let i = 2; i < length; i++) {
    outputSheet.getCell(`${rule.outColChr}${i}`).value = rule.userDefinedData;
  }
};
